import React from "react";

export default function HarvestFrame2({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-har22{fill:#e84d23}.cls-har23{fill:#eaa221}"}</style>
        </defs>
        <path
          d="M1750.81 1730.13H249.19V269.87H1750.8v1460.26Zm-1412.43-89.18h1323.24V359.05H338.38v1281.89Z"
          style={{
            fill: "#ffebbb",
          }}
        />
        <path
          d="m390.62 284.96-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har23"
        />
        <path
          d="m442.53 343.97-34.07-59.01h68.14l-34.07 59.01zM341.42 343.97l-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har22"
        />
        <path
          d="m492.24 284.96-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har23"
        />
        <path
          d="m544.14 343.97-34.06-59.01h68.13l-34.07 59.01z"
          className="cls-har22"
        />
        <path
          d="m593.85 284.96-34.06 59.01h68.13l-34.07-59.01z"
          className="cls-har23"
        />
        <path
          d="m645.76 343.97-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har22"
        />
        <path
          d="m695.47 284.96-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har23"
        />
        <path
          d="m747.38 343.97-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har22"
        />
        <path
          d="m797.09 284.96-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har23"
        />
        <path
          d="m849 343.97-34.07-59.01h68.13L849 343.97z"
          className="cls-har22"
        />
        <path
          d="m898.71 284.96-34.07 59.01h68.13l-34.06-59.01z"
          className="cls-har23"
        />
        <path
          d="m950.61 343.97-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har22"
        />
        <path
          d="m1000.32 284.96-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har23"
        />
        <path
          d="m1052.23 343.97-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har22"
        />
        <path
          d="m1101.94 284.96-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har23"
        />
        <path
          d="m1153.85 343.97-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har22"
        />
        <path
          d="m1203.56 284.96-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har23"
        />
        <path
          d="m1255.46 343.97-34.06-59.01h68.13l-34.07 59.01z"
          className="cls-har22"
        />
        <path
          d="m1305.17 284.96-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har23"
        />
        <path
          d="m1357.08 343.97-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har22"
        />
        <path
          d="m1406.79 284.96-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har23"
        />
        <path
          d="m1458.7 343.97-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har22"
        />
        <path
          d="m1508.41 284.96-34.07 59.01h68.14l-34.07-59.01zM1612.58 284.96l-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har23"
        />
        <path
          d="m1560.32 343.97-34.07-59.01h68.13l-34.06 59.01zM1661.76 343.97l-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har22"
        />
        <path
          d="m390.62 1715.04-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har23"
        />
        <path
          d="m442.53 1656.03-34.07 59.01h68.14l-34.07-59.01zM341.42 1656.03l-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har22"
        />
        <path
          d="m492.24 1715.04-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har23"
        />
        <path
          d="m544.14 1656.03-34.06 59.01h68.13l-34.07-59.01z"
          className="cls-har22"
        />
        <path
          d="m593.85 1715.04-34.06-59.01h68.13l-34.07 59.01z"
          className="cls-har23"
        />
        <path
          d="m645.76 1656.03-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har22"
        />
        <path
          d="m695.47 1715.04-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har23"
        />
        <path
          d="m747.38 1656.03-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har22"
        />
        <path
          d="m797.09 1715.04-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har23"
        />
        <path
          d="m849 1656.03-34.07 59.01h68.13L849 1656.03z"
          className="cls-har22"
        />
        <path
          d="m898.71 1715.04-34.07-59.01h68.13l-34.06 59.01z"
          className="cls-har23"
        />
        <path
          d="m950.61 1656.03-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har22"
        />
        <path
          d="m1000.32 1715.04-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har23"
        />
        <path
          d="m1052.23 1656.03-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har22"
        />
        <path
          d="m1101.94 1715.04-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har23"
        />
        <path
          d="m1153.85 1656.03-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har22"
        />
        <path
          d="m1203.56 1715.04-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har23"
        />
        <path
          d="m1255.46 1656.03-34.06 59.01h68.13l-34.07-59.01z"
          className="cls-har22"
        />
        <path
          d="m1305.17 1715.04-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har23"
        />
        <path
          d="m1357.08 1656.03-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har22"
        />
        <path
          d="m1406.79 1715.04-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har23"
        />
        <path
          d="m1458.7 1656.03-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har22"
        />
        <path
          d="m1508.41 1715.04-34.07-59.01h68.14l-34.07 59.01zM1612.58 1715.04l-34.07-59.01h68.14l-34.07 59.01z"
          className="cls-har23"
        />
        <path
          d="m1560.32 1656.03-34.07 59.01h68.13l-34.06-59.01zM1661.76 1656.03l-34.07 59.01h68.14l-34.07-59.01z"
          className="cls-har22"
        />
        <path
          d="m265.97 1609.33 59.01 34.07v-68.14l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m324.98 1557.42-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m265.97 1507.71 59.01 34.07v-68.14l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m324.98 1455.8-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m265.97 1406.09 59.01 34.07v-68.14l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m324.98 1354.19-59.01 34.06v-68.13l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m265.97 1304.48 59.01 34.06v-68.13l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m324.98 1252.57-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m265.97 1202.86 59.01 34.07v-68.14l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m324.98 1150.95-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m265.97 1101.24 59.01 34.07v-68.14l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m324.98 1049.33-59.01 34.07v-68.13l59.01 34.06z"
          className="cls-har22"
        />
        <path
          d="m265.97 999.63 59.01 34.06v-68.13l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m324.98 947.72-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m265.97 898.01 59.01 34.07v-68.14l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m324.98 846.1-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m265.97 796.39 59.01 34.07v-68.14l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m324.98 744.48-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m265.97 694.77 59.01 34.07v-68.13l-59.01 34.06z"
          className="cls-har23"
        />
        <path
          d="m324.98 642.87-59.01 34.07V608.8l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m265.97 593.16 59.01 34.07v-68.14l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m324.98 541.25-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m265.97 491.54 59.01 34.07v-68.14l-59.01 34.07zM265.97 387.37l59.01 34.07V353.3l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m324.98 439.63-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m1675.67 1559.76 59.01 34.07v-68.14l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m1734.68 1507.85-59.01 34.07v-68.14l59.01 34.07zM1734.68 1608.52l-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m1675.67 1458.14 59.01 34.07v-68.14l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m1734.68 1406.23-59.01 34.07v-68.13l59.01 34.06z"
          className="cls-har22"
        />
        <path
          d="m1675.67 1356.52 59.01 34.07v-68.13l-59.01 34.06z"
          className="cls-har23"
        />
        <path
          d="m1734.68 1304.62-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m1675.67 1254.91 59.01 34.07v-68.14l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m1734.68 1203-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m1675.67 1153.29 59.01 34.07v-68.14l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m1734.68 1101.38-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m1675.67 1051.67 59.01 34.07v-68.13l-59.01 34.06z"
          className="cls-har23"
        />
        <path
          d="m1734.68 999.77-59.01 34.06V965.7l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m1675.67 950.06 59.01 34.07v-68.14l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m1734.68 898.15-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m1675.67 848.44 59.01 34.07v-68.14l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m1734.68 796.53-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m1675.67 746.82 59.01 34.07v-68.14l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m1734.68 694.92-59.01 34.06v-68.13l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m1675.67 645.21 59.01 34.06v-68.13l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m1734.68 593.3-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m1675.67 543.59 59.01 34.07v-68.14l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m1734.68 491.68-59.01 34.07v-68.14l59.01 34.07z"
          className="cls-har22"
        />
        <path
          d="m1675.67 441.97 59.01 34.07V407.9l-59.01 34.07z"
          className="cls-har23"
        />
        <path
          d="m1734.68 390.06-59.01 34.07V356l59.01 34.06z"
          className="cls-har22"
        />
        {children}
      </g>
    </svg>
  );
}
